import { useEffect } from 'react';
import { useShallow } from 'zustand/shallow';

import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

import type { FrustumViewerMessage } from 'app/modules/wallforming/components/frustum-viewer/types/frustumViewerMessage';

/**
 * useFrustumMessageHandler — Hook to receive and process postMessage events from the main app window.
 *
 * Updates the local frustum viewer store with camera and scene data sent from the main app.
 * Should be used in a component that is always mounted while the frustum viewer is active.
 */
export const useFrustumMessageHandler = () => {
    const setCameraHelperData = usePlacementStore(useShallow((state) => state.setCameraHelperData));

    useEffect(() => {
        const handleOnCameraUpdateMessage = (event: MessageEvent<FrustumViewerMessage>) => {
            if (!event.data?.type) {
                return;
            }
            if (event.data.type === 'CAMERA_FRUSTUM_UPDATE') {
                setCameraHelperData(event.data.camera);
            }
        };
        window.addEventListener('message', handleOnCameraUpdateMessage);
        return () => window.removeEventListener('message', handleOnCameraUpdateMessage);
    }, [setCameraHelperData]);
};
